Model = require('./Model').default
DataEntry = require('models/DataEntry')
Stereotypes = require('models/Stereotypes')
RecordBrowserState = require('models/RecordBrowserState')
userStore = require("data/userStore").default
contextKeyFactory = require("data/util/ContextedReduceStore").keyFactory
Dispatcher = require("Dispatcher").default
ContextActions = require("data/util/ContextActions").default
SuperRecordActions = require("data/SuperRecordActions").default
{ ACTION_CONTEXT_KEY } = require("data/util/ContextedReduceStore")
{ isConfirmed } = require("data/OverStore")

module.exports = class AppModel extends Model
    defaults: ->
        fluxContext: contextKeyFactory()
        stereotypes: new Stereotypes()
        lookups: new Stereotypes()
        recordBrowserState: new RecordBrowserState()
        dataEntry: new DataEntry()
        isModal: false

        # previously anonymous attributes
        hex: null
        dataQualityReport: null

    initialize: () ->
        @__dispatch_token = Dispatcher.register (action) =>
            return if (action[ACTION_CONTEXT_KEY] != @get("fluxContext"))
            switch action.type
                when ContextActions.CLOSE
                    Dispatcher.unregister(@__dispatch_token)

    buildNewMenu: (root)=>
        if ! root?
            throw new Error 'root is required to build menu'

        tree = new Backbone.Collection()
        org = userStore.getActiveOrg()
        _(root.get('creatables').filter (c) ->
            _(c.get('orgs')).contains(org.key)
        ).each (c) ->
            if c.has("defaultKey")
                def = c.get("versions").find (v) ->
                    v.get('key') == c.get('defaultKey')
            label = c.get('label')
            if def?
                tree.add new Backbone.Model(
                    label: label,
                    key: def.get('key'),
                    org: org.key,
                    entity: root.get('key')
                )
            else
                c.get("versions").each (v) ->
                    tree.add new Backbone.Model(
                        label: label + " > " + v.get('label'),
                        key: v.get('key'),
                        org: org.key,
                        entity: root.get('key')
                    )
        @squishMenuList tree

    squishMenuList: (list)=>
        result = new Backbone.Collection()
        for item in list.models
            result.add(@squishMenuItem(item))
        result

    squishMenuItem: (item)=>
        if item.get("kids")
            kids = @squishMenuList(item.get("kids"))
            item.set("kids", kids)
            if kids.size() == 1
                kid = kids.pop() # remove it
                kid.set("label", item.get("label") + " > " + kid.get("label"))
                return kid
        item

# set : (attributes, options)=>
# 	if attributes == "activeRecord"
# 		debugger
# 	return Backbone.Model.prototype.set.call(this, attributes, options)



// WEBPACK FOOTER //
// ./app/models/AppModel.coffee